import {
  Flower2,
  Cigarette,
  Cookie,
  Droplets,
  Gem,
  Candy,
  Grid,
  Wrench,
  Shirt,
  ShoppingBasket,
  Coffee,
  Pill,
  Gift,
  Sparkles,
  Hand,
  Wind,
  Leaf,
  Star,
  Package,
  Tag,
  Receipt,
  DoorOpen,
  DollarSign,
  Check,
  Pause,
  Trash2,
  UserCog,
  CreditCard,
  Wallet,
  ReceiptText,
  Percent,
  Printer,
  FileSearch,
  BadgeDollarSign,
  RotateCcw,
  ArrowDownToLine,
  ArrowUpFromLine,
  ArrowRightFromLine,
  ClipboardList,
  Calculator,
  LogOut,
  User,
  Phone,
  Mail,
  Calendar,
  TrendingUp,
  ShoppingCart,
  Clock,
  StickyNote,
  ChevronDown,
  ChevronRight,
  ArrowLeft,
  Plus,
  type LucideProps,
} from 'lucide-react'
import type { ComponentType } from 'react'

type IconComponent = ComponentType<LucideProps>

export const iconMap: Record<string, IconComponent> = {
  Flower: Flower2,
  Cigarette: Cigarette,
  Cookie: Cookie,
  Droplets: Droplets,
  Gem: Gem,
  Candy: Candy,
  Grid: Grid,
  Wrench: Wrench,
  Shirt: Shirt,
  ShoppingBasket: ShoppingBasket,
  Coffee: Coffee,
  Pill: Pill,
  Gift: Gift,
  Sparkles: Sparkles,
  Hand: Hand,
  Wind: Wind,
  Leaf: Leaf,
  Star: Star,
  Package: Package,
  Tag: Tag,
  Receipt: Receipt,
  DoorOpen: DoorOpen,
  DollarSign: DollarSign,
  Check: Check,
  Pause: Pause,
  Trash2: Trash2,
  UserCog: UserCog,
  CreditCard: CreditCard,
  Wallet: Wallet,
  ReceiptText: ReceiptText,
  Percent: Percent,
  Printer: Printer,
  FileSearch: FileSearch,
  BadgeDollarSign: BadgeDollarSign,
  RotateCcw: RotateCcw,
  ArrowDownToLine: ArrowDownToLine,
  ArrowUpFromLine: ArrowUpFromLine,
  ArrowRightFromLine: ArrowRightFromLine,
  ClipboardList: ClipboardList,
  Calculator: Calculator,
  LogOut: LogOut,
  User: User,
  Phone: Phone,
  Mail: Mail,
  Calendar: Calendar,
  TrendingUp: TrendingUp,
  ShoppingCart: ShoppingCart,
  Clock: Clock,
  StickyNote: StickyNote,
  ChevronDown: ChevronDown,
  ChevronRight: ChevronRight,
  ArrowLeft: ArrowLeft,
  Plus: Plus,
}

// Map category names to icon names
export const categoryIconMap: Record<string, string> = {
  flower: 'Flower',
  'pre-rolls': 'Cigarette',
  preroll: 'Cigarette',
  edibles: 'Cookie',
  oils: 'Droplets',
  tinctures: 'Droplets',
  concentrates: 'Gem',
  extracts: 'Gem',
  vapes: 'Wind',
  cartridges: 'Wind',
  capsules: 'Pill',
  topicals: 'Hand',
  accessories: 'ShoppingBasket',
  beverages: 'Coffee',
  apparel: 'Shirt',
  gift: 'Gift',
  sale: 'Sparkles',
}

export function getCategoryIcon(categoryName: unknown): string {
  // The legacy /ht/api/objects/products endpoint returns `category` as a
  // numeric id rather than a name, so coerce defensively before string ops.
  if (typeof categoryName !== 'string' || !categoryName) return 'Package'
  const key = categoryName.toLowerCase().replace(/\s+/g, '-')
  for (const [pattern, icon] of Object.entries(categoryIconMap)) {
    if (key.includes(pattern) || pattern.includes(key)) {
      return icon
    }
  }
  return 'Package'
}

export interface ProductIconProps {
  name: string
  size?: number
  className?: string
}

export function ProductIcon({ name, size = 20, className = '' }: ProductIconProps) {
  const Icon = iconMap[name] || iconMap.Package
  return Icon ? <Icon size={size} className={className} /> : null
}

export function getIcon(name: string): IconComponent | null {
  return iconMap[name] || null
}
